export const GET_SWITCH_DATE = "getSwitchDate"
export const GET_ENERGY_ON_SUPPLY = "getEnergyOnSupply"
export const GET_SMART_METER_APPOINTMENT_DATE = "getSmartMeterAppointmentDate"
export const GET_SMART_METER_APPOINTMENT_TIME = "getSmartMeterAppointmentTime"
